import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, renderNothing, renderComponent, branch, withStateHandlers } from 'recompose'
import { Table, TableCell, TableHead, TableRow } from 'react-toolbox/lib/table'
import CSSModules from 'helpers/CSSModulesUtil'
import * as R from 'ramda'
import P from 'helpers/predicates'
import _ from 'lodash'
import { Flex } from 'reflexbox'

import Text from 'components/typography/subheading'
import HeaderMenu from 'components/custom/HeaderMenu'
import SortIcon from 'components/custom/SortIcon'

import styles from './styles.scss'
import { filterTable, sortTable } from './util'
import cn from 'classnames';

const withHeadMenuStates = withStateHandlers(
  ({ activeMenuKey = null }) => ({
    activeMenuKey
  }),
  {
    _onMenuSubmit: (_, { onMenuSubmit }) => (filterObj) => {
      onMenuSubmit(filterObj)
      return ({
        activeMenuKey: null
      })
    },
    _onClickHeaderCell: ({ activeMenuKey }) => (key) => {
      return ({
        activeMenuKey: key
      })
    },
    _onHideHeaderCell: ({ activeMenuKey }) => () => {
      return ({
        activeMenuKey: null
      })
    }
  }
)

const getTableHead = (tableHeadContent, source, onClick, onHide, onMenuSubmit, activeMenuKey, tableSort) => {

  const sortIconKey = !_.isEmpty(tableSort) ? _.keys(tableSort)[0] : null
  const sortBy = !_.isEmpty(tableSort) ? tableSort[sortIconKey] : null

  return (
    <TableHead>
      {
        _.map(tableHeadContent, (content, key) => (
          <TableCell key={key} onClick={() => onClick(key)}>
            <Flex auto align='center'>
              {content}
              <SortIcon
                currentIndex={key}
                columnIndex={sortIconKey}
                sortBy={sortBy} />
            </Flex>
            <div styleName="headerMenuContainer">
              <HeaderMenu
                active={activeMenuKey === key}
                onHide={onHide} sortEnabled={true}
                inputHeaderSource={_.map(source, s => _.toString(s[key]))}
                onChange={() => { }}
                onKeyPress={() => { }}
                onClick={(filterObj) => onMenuSubmit({ [key]: filterObj })}
              />
            </div>
          </TableCell>
        ))
      }
    </TableHead>
  )
}


const EmptyComponent = () => (
  <div styleName='emptyComponent'>
    <Text>
      No reports submitted
    </Text>
  </div>
)

const showRowContent = (content) => {
  var displayString = ""
  if (Array.isArray(content)) {
    content.forEach((value, index) => {
      if (index > 0) {
        displayString += ", "
      }
      displayString += value
    })
  } else {
    displayString = content
  }
  return displayString
}

const getViewTableRows = (source, tableHeadContent, onRowClick) => {
  const mapIndexed = R.addIndex(R.map);
  return (
    mapIndexed((rowContent, rowIdx) => (
      <TableRow key={rowIdx} onClick={() => onRowClick(rowIdx)}>
        {mapIndexed((key, cellIdx) => (
          <TableCell key={cellIdx}>{(rowContent && rowContent[key]) ? showRowContent(rowContent[key]) : ""}</TableCell>
        ), R.keys(tableHeadContent))}
      </TableRow>
    ), source)
  )
}

const TableComponent = ({ onRowClick, source, sourceVal = source, tableFilter, tableSort, tableHeadContent, selectable, _onClickHeaderCell, _onHideHeaderCell, _onMenuSubmit, activeMenuKey, classNames }) => {

  let filteredSource = []
  const filterAndSort = _.flowRight([(s) => sortTable(s, tableSort), (s) => filterTable(s, tableFilter)])
  const filteredSourceVal = filterAndSort(sourceVal.map((x, idx) => ({...x, idx})))
  filteredSourceVal.forEach(({ idx }) => { filteredSource.push(source[idx]) })

  return (
    <div styleName="tableContainer">
      <Table theme={styles} selectable={selectable}>
        {getTableHead(tableHeadContent, sourceVal, _onClickHeaderCell, _onHideHeaderCell, _onMenuSubmit, activeMenuKey, tableSort)}
        {getViewTableRows(filteredSource, tableHeadContent, onRowClick)}
      </Table>
    </div>
  )
}


TableComponent.propTypes = {
  selectable: PropTypes.bool.isRequired,
}

TableComponent.defaultProps = {
  selectable: false,
}

const withStyle = CSSModules(styles)

const enhance = compose(
  withHeadMenuStates,
  branch(R.propSatisfies(R.isEmpty, 'source'),
    R.compose(
      renderComponent,
      withStyle
    )(EmptyComponent)
  ),
  withStyle
)
export default enhance(TableComponent)
